import { type UseQueryResult, useQuery } from 'react-query';
import { SandboxService } from '../../services/wealthlane-identity-services';

const useGetSandboxVisibilityOptions = (
    handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
    | Array<{
        label: string;
        value: string | number;
    }>
    | undefined,
    unknown
> => {
    const sandboxVisibilityOptions = useQuery(
        ['getSandboxVisibilityOptions'],
        async () => {
            return await handleRequest(SandboxService.getApiIdentityApiSandboxOptionsVisibility());
        },
        {
            select: (data) => {
                return data?.map((item) => {
                    return {
                        label: item.name ?? '',
                        value: item.id ?? '',
                    };
                });
            },
        }
    );

    return sandboxVisibilityOptions;
};

export default useGetSandboxVisibilityOptions;

